// extracted by mini-css-extract-plugin
module.exports = {"profileSwitcher":"_1ZjswcQXQ6PtGeOvvngQgj","profileSwitcherImage":"_2iRb0c4YpXQobUV6WKXhwu"};